import { createBrowserRouter } from 'react-router-dom';
import App from './app';
import { ChatPage } from '../pages/chat/chat-page';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '',
        element: <ChatPage />,
      },
    ],
  },
]);
